import './TaggedBlogPosts.css';
import React from "react";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom'

function TaggedBlogPosts() {
    const { tag } = useParams();
    const blogs = useSelector((state) => state.counter.blogs);

    let tagFilteredBlogs = blogs.filter(({ keywords }) => keywords.includes(tag));
    let sortedBlogs = tagFilteredBlogs.sort((a, b) => new Date(...a.postDate.split('/').reverse()) - new Date(...b.postDate.split('/').reverse()));

    return (
        <>
        <section className="header-tag">
            <h4>#{tag}</h4>
        </section>
        <section className="tagged-content">
            <div className="blog-items">
                <h3>Posts</h3>
            </div>
            <div className="blog-items">
                {sortedBlogs.map(function(d, idx){
                    return (
                        <div className="blog-item" key={idx}>
                            <div className="blog-title">
                            <a className="blog-item-link" href={d.link}>
                            {d.name}
                            </a>
                            </div>
                            <div className="blog-date">
                                {d.postDate}
                            </div>
                        </div>
                    )
                })}
            </div>
        </section>
        </>
    )
}
                
export default TaggedBlogPosts;